'use client';

import {useRouter, usePathname} from 'next/navigation';
import {useTranslation} from 'react-i18next';
import i18nConfig from '../i18nConfig';
import {MenuItem, Select, FormControl, Typography} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import pl from '../assets/flags/pl.png';
import en from '../assets/flags/en.png';
import de from '../assets/flags/de.png';

const translationsLanguages = {
  en: {label: 'English', code: 'EN', flag: en.src},
  pl: {label: 'Polski', code: 'PL', flag: pl.src},
  de: {label: 'Deutsch', code: 'DE', flag: de.src},
};

export default function LanguageChanger() {
  const {t, i18n} = useTranslation();
  const currentLocale = i18n.language;
  const router = useRouter();
  const currentPathname = usePathname();
  const matches = useMediaQuery('(min-width: 1650px)');
  const mobileMatches = useMediaQuery('(max-width: 1400px)');

  const handleChange = e => {
    const newLocale = e.target.value;

    // set cookie for next-i18n-router
    const days = 30;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = date.toUTCString();
    document.cookie = `NEXT_LOCALE=${newLocale};expires=${expires};path=/`;

    // redirect to the new locale path
    if (
      currentLocale === i18nConfig.defaultLocale &&
      !i18nConfig.prefixDefault
    ) {
      router.push('/' + newLocale + currentPathname);

    } else {
      router.push(
        currentPathname ? currentPathname.replace(`/${currentLocale}`, `/${newLocale}`) : `/${newLocale}`
      );
    }
    i18n.changeLanguage(newLocale);
    e.preventDefault();
    router.refresh();
  };

  return (
    <FormControl sx={{m: 1, width: '100%', maxWidth: '130px'}} size="small">
      <Select
        value={currentLocale}
        onChange={handleChange}
      >
        {i18nConfig.locales.map(locale => (
          <MenuItem key={locale} value={locale}>
            <Typography variant="body2" sx={{textTransform: 'capitalize', display: 'flex', alignItems: 'center'}}>
              <img src={translationsLanguages[locale].flag} width="20px" style={{margin: '6px auto', padding: '2px'}} />
              {matches ? translationsLanguages[locale].label
                :
                (mobileMatches ? '' : translationsLanguages[locale].code)
              }
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}